/* EcoRain: info-tooltip ('i') bij upsell-onderdelen in 'Maak je bestelling compleet' */
(function(){
  var INFO=[
    {m:/douchearm 38/i, t:'Muurarm voor je regendouchekop. Schroef je aan de muur; de douchekop draait erop vast.'},
    {m:/plafond.*arm/i, t:'Hiermee hangt je regendouchekop aan het plafond i.p.v. de muur, zodat het water recht van bovenaf neervalt. De kop schroef je op het uiteinde — universele G½, past op alle EcoRain-koppen.'},
    {m:/doucheslang/i, t:'Flexibele slang van 150 cm. Sluit je douchekop aan op je bestaande kraan.'},
    {m:/aansluitingsslang/i, t:'Korte aansluitslang om je douche op de wateraansluiting te koppelen.'},
    {m:/glijstang/i, t:'Verstelbare stang met houder; schuif je handdouche eenvoudig op de gewenste hoogte.'},
    {m:/tussenstuk|muurkoppeling/i, t:'Koppelstuk om de doucheslang op de douchearm aan te sluiten.'}
  ];
  function lookup(s){for(var i=0;i<INFO.length;i++){if(INFO[i].m.test(s))return INFO[i].t;}return null;}
  function injectStyle(){
    if(document.getElementById('er-upsell-info-style'))return;
    var st=document.createElement('style');st.id='er-upsell-info-style';
    st.textContent='.meta-product-main .horizontal-product{position:relative;}.er-info-wrap{position:absolute;top:5px;right:5px;display:inline-flex;z-index:8;margin:0;}.er-info-btn{width:14px;height:14px;min-width:14px;border-radius:50%!important;border:none!important;background:rgba(147,182,156,.35)!important;color:#05182d!important;cursor:pointer;padding:0!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;opacity:.7;transition:opacity .15s ease,background .15s ease;}.er-info-btn svg{display:block;width:8px;height:8px;}.er-info-btn:hover,.er-info-wrap.is-open .er-info-btn{opacity:1;background:rgba(147,182,156,.7)!important;}.er-info-pop{position:absolute;top:160%;right:0;background:#05182d;color:#fff;font-size:12px;line-height:1.35;font-weight:400;padding:8px 10px;border-radius:8px;width:215px;max-width:68vw;box-shadow:0 6px 18px rgba(5,24,45,.25);opacity:0;visibility:hidden;transition:opacity .15s ease,visibility .15s ease;z-index:70;text-align:left;white-space:normal;pointer-events:none;}.er-info-pop::after{content:"";position:absolute;bottom:100%;right:4px;border:6px solid transparent;border-bottom-color:#05182d;}.er-info-wrap:hover .er-info-pop,.er-info-wrap.is-open .er-info-pop{opacity:1;visibility:visible;}';
    document.head.appendChild(st);
  }
  function build(){
    var root=document.querySelector('.meta-product-main');if(!root)return;
    var items=root.querySelectorAll('.horizontal-product');if(!items.length)return;
    injectStyle();
    Array.prototype.forEach.call(items,function(it){
      if(it.querySelector('.er-info-wrap'))return;
      var titleEl=it.querySelector('.recommendations-title')||it.querySelector('.meta-product-info a');if(!titleEl)return;
      var txt=lookup(titleEl.textContent||'');if(!txt)return;
      var wrap=document.createElement('span');wrap.className='er-info-wrap';
      var btn=document.createElement('button');btn.type='button';btn.className='er-info-btn';btn.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="2.3"></circle><rect x="9.9" y="9.3" width="4.2" height="10" rx="2.1"></rect></svg>';btn.setAttribute('aria-label','Meer informatie');
      var pop=document.createElement('span');pop.className='er-info-pop';pop.textContent=txt;
      function show(){wrap.classList.add('is-open');}
      function hide(){wrap.classList.remove('is-open');}
      btn.addEventListener('pointerenter',show);
      btn.addEventListener('pointerleave',hide);
      btn.addEventListener('pointerdown',function(e){e.preventDefault();show();});
      btn.addEventListener('pointerup',hide);
      btn.addEventListener('pointercancel',hide);
      btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();});
      wrap.appendChild(btn);wrap.appendChild(pop);
      it.appendChild(wrap);
    });
  }
  if(document.readyState!=='loading'){build();}else{document.addEventListener('DOMContentLoaded',build);}
  document.addEventListener('shopify:section:load',build);
  var n=0,iv=setInterval(function(){n++;build();if(n>20)clearInterval(iv);},400);
})();


  // EcoRain: accordeons sluiten elkaar niet meer dwingend -> geen scroll-sprong bij openklappen
  let questions = document.querySelectorAll(".questions");
  questions.forEach(questions => {
    questions.addEventListener("click", event => {
      questions.classList.toggle("active");
      const answers = questions.nextElementSibling;
      if (questions.classList.contains("active")) {
        answers.style.maxHeight = answers.scrollHeight + "px";
      } else {
        answers.style.maxHeight = 0;
      }
    })
  })


const content = document.getElementById('content-tabs');
const toggleButton = document.getElementById('toggleButton');

// Define translations
const translations = {
  en: {
    read_more: 'Read more',
    read_less: 'Read less'
  },
  nl: {
    read_more: 'Lees verder',
    read_less: 'Lees minder'
  },
  de: {
    read_more: 'Mehr lesen',
    read_less: 'Weniger lesen'
  }
};

// Detect the language, default to 'en' (English)
const language = document.documentElement.lang || 'en'; // You can replace this with your logic to detect the language

if (toggleButton && content) {
toggleButton.addEventListener('click', () => {
  if (content.style.maxHeight) {
    content.style.maxHeight = null;
    toggleButton.textContent = translations[language].read_more;
    content.classList.remove('active');
  } else {
    content.style.maxHeight = content.scrollHeight + 'px';
    toggleButton.textContent = translations[language].read_less;
    content.classList.add('active');
  }
});
}




function togglePopup(){
  document.getElementById("popup-1").classList.toggle("active");
}




var swiper = new Swiper(".custom-media-slider", {
  spaceBetween: 30,
  centeredSlides: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

/* EcoRain: voorkom scroll-sprong naar boven bij lege anker-links (href="#"), zoals Judge.me review-/paginatie-links. preventDefault stopt alleen de browser-sprong; de app-handlers blijven werken. */
document.addEventListener('click', function(e){
  var a = e.target && e.target.closest ? e.target.closest('a[href="#"], a[href=""]') : null;
  if (a) { e.preventDefault(); }
}, true);
